import CONTENT_MATURITY_GRADE_LEVELS from "@/view/constants/contentMaturityGradeLevels";

/**
 * Returns a string representing the range of maturities.
 * If the first and last maturity values are different, it returns "first – last".
 * If they are the same, it returns just the single value.
 * @param {array} maturities - An array of maturity values.
 * @returns {string} - A string representing the maturity range.
 */
export const getMaturityRange = (maturities) => {
  if (maturities) {
    const firstMaturity = maturities[0];
    const lastMaturity = maturities[maturities.length - 1];

    return lastMaturity !== firstMaturity
      ? `${firstMaturity} – ${lastMaturity}`
      : firstMaturity;
  }
};

/**
 * Return an array of two elements representing the best matching content maturity range
 * @param {array} maturities // ex: [5, 12]
 * @returns {array} // ex: ['Lower Elementary School', 'High School'] or ['Upper Elementary School']
 */

const getBestMatchingMaturityBands = (maturities) => {
  const lowerGradeBound = maturities[0];
  const upperGradeBound = maturities[maturities.length - 1];
  if (!lowerGradeBound && !upperGradeBound) {
    return Object.keys(CONTENT_MATURITY_GRADE_LEVELS);
  } else {
    const maturityBands = [];
    for (const band in CONTENT_MATURITY_GRADE_LEVELS) {
      const preferredGradeRange = [];
      for (let i = lowerGradeBound; i <= upperGradeBound; i++) {
        preferredGradeRange.push(i);
      }
      if (
        preferredGradeRange.includes(CONTENT_MATURITY_GRADE_LEVELS[band][0]) &&
        preferredGradeRange.includes(CONTENT_MATURITY_GRADE_LEVELS[band][1])
      ) {
        maturityBands.push(band);
      }
    }
    return maturityBands;
  }
};

export default getBestMatchingMaturityBands;
